export function inventoryStateReducer(state = {
        fetching:false,
        fetched: false,
        error:null,
    },{
        type,
        payload
    }){
    
    switch(type){
        case "FETCH_INIT_DATA_START":           
            return {...state, 
                fetching:true
            }        
        case "FETCH_INIT_DATA_FULFILLED":           
            return {...state, fetching:false, fetched:true, error:null }        
        case "FETCH_INIT_DATA_ERROR":
            return {...state, fetching:false, error:payload}   
        default:
            return state;
    }
    
}
